// extracted by mini-css-extract-plugin
export var borderRadius = "_fr-4";
export var large = "_fr-3";
export var logoContainer = "_fr-0";
export var nameLogo = "_fr-2";
export var small = "_fr-1";